import { GoalbarIndicator as GoalbarIndicatorPrimitive } from 'components/goalbar/goalbar-indicator';
import * as Styled from 'components/goalbar/styled';

const Goalbar = Styled.Wrapper;
const GoalbarIndicator = GoalbarIndicatorPrimitive;

const Root = Goalbar;
const Indicator = GoalbarIndicator;

export {
    Goalbar,
    GoalbarIndicator,
    //
    Root,
    Indicator,
};
